import { trigger, state, style, transition, animate, group } from '@angular/animations';

export const CollapseWidthAnimation = trigger('collapseWidth', [
  state('in', style({
    opacity: 1,
    width: '*'
  })),
  transition('void => *', [
    style({
      opacity: 0,
      width: 0
    }),
    animate('0.2s ease-out', style({width: '*'})),
    animate('0.2s', style({opacity: 1}))
  ]),
  transition('* => void', [
    animate('0.2s', style({opacity: 0})),
    animate('0.2s ease-out', style({width: 0}))
  ])
]);


// WEBPACK FOOTER //
// ./src/app/shared/collapse-width.animation.ts